export const convertCopilotV2ThreadToCopilotV1ThreadForRedux = thread => {
  return {
    ablyChannelId: thread.ablyChannelId,
    customCopilotId: thread.customCopilotId,
    id: thread.id,
    label: thread.title,
    labelStatus: 'INITIALIZED',
    createdAt: thread.createdAt,
    userId: thread.userId,
    portalId: thread.portalId,
    isReadOnly: thread.isReadOnly,
    lastMessageAt: null,
    // TODO - @mlegocki: consider removing this field if it unused
    lastMessageId: null,
    // TODO - @mlegocki: consider removing this field if it unused
    isAutoCreated: thread.isAutoCreated,
    boxId: undefined,
    assistantType: undefined
  };
};
export const convertCopilotV2ThreadsToCopilotV1ThreadsForRedux = threads => {
  return threads.map(convertCopilotV2ThreadToCopilotV1ThreadForRedux);
};